import { useState } from 'react';
import ReactModal from 'react-modal';

import Checkbox from 'atoms/checkbox';
import ModalContent from 'atoms/modal-content';

export default function DeleteDayModal({
  isOpen,
  onClose,
  variant,
  onRemoveRange,
}) {
  const [isChecked, check] = useState(false);

  const onConfirm = () => {
    if (isChecked) {
      // This modal won't display again
      localStorage.setItem('hideAvailabilityRemovalModal', true);
    }
    onClose(false);
    onRemoveRange({});
  };

  const text = () => {
    let type = 'this time slot';
    if (variant === 'day') {
      type = 'all time slots on this day';
    }
    return `Are you sure you want to remove ${type}? It will no longer be bookable on PawCare. We recommend you review, and reschedule your appointments before making this change.`;
  };

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={() => onClose(false)}
    >
      <ModalContent
        title="Are you sure?"
        primaryButton="Confirm"
        primaryButtonAction={onConfirm}
        onClose={() => onClose(false)}
      >
        <p>{text()}</p>
        <Checkbox
          id={variant}
          value={isChecked}
          disableInternalCheck
          variant="consent"
          className="mt-20"
          onClick={({ isChecked }) => check(isChecked)}
        >
          <p className="f15 c-primary-purple">Do not display again</p>
        </Checkbox>
      </ModalContent>
    </ReactModal>
  );
}
